<template>
    <div>
        <v-container pt-0>
            <v-layout row>
                 <v-flex xs12 class="pb-4">
                    <v-btn-toggle class="mt-2" mandatory v-model="hitting_pitching">
                        <v-btn value="hitting">Hitting</v-btn>
                        <v-btn value="pitching">Pitching</v-btn>
                    </v-btn-toggle>
                    <v-divider class="mx-2" inset vertical></v-divider>
                    <v-btn-toggle class="mt-2" mandatory v-model="player_team">
                        <v-btn flat value="player">Player</v-btn>
                        <v-btn flat value="team">Team</v-btn>
                    </v-btn-toggle>
                    <v-divider class="mx-2" inset vertical></v-divider>
                    <v-btn-toggle class="mt-2" mandatory v-model="season_playoffs">
                        <v-btn flat value="season">Season</v-btn>
                        <v-btn flat value="playoffs">Playoffs</v-btn>
                    </v-btn-toggle>
                 </v-flex>
            </v-layout>
            <v-layout column>
                <v-flex xs12>
                    <v-card>
                        <v-data-table
                            v-bind:headers="headers_hitter_player"
                            v-bind:items="getDataSet"
                            hide-actions
                            v-if="hitting_pitching === 'hitting' && player_team === 'player'"
                        >
                            <template v-slot:items="props">
                                <td>{{ getPlayerFullName(props.item.player_id) }}</td>
                                <td>
                                    <team-badge
                                        v-bind:team="getTeamById(props.item.team_id).team"
                                        v-bind:colour="getTeamById(props.item.team_id).colour"
                                        width="120px"
                                    ></team-badge>
                                </td>
                                <td class="text-xs-right">{{ props.item.hr }}</td>
                                <td v-if="admin" class="justify-center layout px-0">
                                    <v-icon
                                        small
                                        class="mr-2"
                                        v-on:click="issueEdit(props.item)"
                                    >
                                        edit
                                    </v-icon>
                                    <v-icon
                                        small
                                        v-on:click="issueDelete(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                            </template>
                        </v-data-table>

                        <v-data-table
                            v-bind:headers="headers_hitter_team"
                            v-bind:items="getDataSet"
                            hide-actions
                            v-if="hitting_pitching === 'hitting' && player_team === 'team'"
                        >
                            <template v-slot:items="props">
                                <td>
                                    <team-badge
                                        v-bind:team="getTeamById(props.item.team_id).team"
                                        v-bind:colour="getTeamById(props.item.team_id).colour"
                                        width="120px"
                                    ></team-badge>
                                </td>
                                <td class="text-xs-right">{{ props.item.hr }}</td>
                            </template>
                        </v-data-table>

                        <v-data-table
                            v-bind:headers="headers_pitcher_player"
                            v-bind:items="getDataSet"
                            hide-actions
                            v-if="hitting_pitching === 'pitching' && player_team === 'player'"
                        >
                            <template v-slot:items="props">
                                <td>{{ getPlayerFullName(props.item.player_id) }}</td>
                                <td>
                                    <team-badge
                                        v-bind:team="getTeamById(props.item.team_id).team"
                                        v-bind:colour="getTeamById(props.item.team_id).colour"
                                        width="120px"
                                    ></team-badge>
                                </td>
                                <td class="text-xs-right">{{ props.item.so }}</td>
                                <td class="text-xs-right">{{ props.item.ip }}</td>
                                <td v-if="admin" class="justify-center layout px-0">
                                    <v-icon
                                        small
                                        class="mr-2"
                                        v-on:click="issueEdit(props.item)"
                                    >
                                        edit
                                    </v-icon>
                                    <v-icon
                                        small
                                        v-on:click="issueDelete(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                            </template>
                        </v-data-table>

                        <v-data-table
                            v-bind:headers="headers_pitcher_team"
                            v-bind:items="getDataSet"
                            hide-actions
                            v-if="hitting_pitching === 'pitching' && player_team === 'team'"
                        >
                            <template v-slot:items="props">
                                <td>
                                    <team-badge
                                        v-bind:team="getTeamById(props.item.team_id).team"
                                        v-bind:colour="getTeamById(props.item.team_id).colour"
                                        width="120px"
                                    ></team-badge>
                                </td>
                                <td class="text-xs-right">{{ props.item.so }}</td>
                                <td class="text-xs-right">{{ props.item.ip }}</td>
                            </template>
                        </v-data-table>

                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import TeamBadge from './TeamBadge.vue'

export default {
    name: 'StatisticsGrid',
    props: ['admin'],
    data() {
        return {
            exact: true,
            hitting_pitching: 'hitting',
            player_team: 'player',
            season_playoffs: 'season',
            season_search: '',
            playoff_search: '',
            headers_hitter_player: [
                {
                    text: 'Player',
                    align: 'left',
                    sortable: false,
                    value: 'player',
                    width: '200px'
                },
                {
                    text: 'Team',
                    align: 'left',
                    sortable: false,
                    value: 'team',
                    width: '120px'
                },
                {
                    text: 'HR',
                    align: 'right',
                    sortable: false,
                    value: 'hr'
                }
            ],
            headers_hitter_team: [
                {
                    text: 'Team',
                    align: 'left',
                    sortable: false,
                    value: 'team',
                    width: '120px'
                },
                {
                    text: 'HR',
                    align: 'right',
                    sortable: false,
                    value: 'hr'
                }
            ],
            headers_pitcher_player: [
                {
                    text: 'Player',
                    align: 'left',
                    sortable: false,
                    value: 'player',
                    width: '200px'
                },
                {
                    text: 'Team',
                    align: 'left',
                    sortable: false,
                    value: 'team',
                    width: '120px'
                },
                {
                    text: 'SO',
                    align: 'right',
                    sortable: true,
                    value: 'so'
                },
                {
                    text: 'IP',
                    align: 'right',
                    sortable: true,
                    value: 'ip'
                }
            ],
            headers_pitcher_team: [
                {
                    text: 'Team',
                    align: 'left',
                    sortable: false,
                    value: 'team',
                    width: '120px'
                },
                {
                    text: 'SO',
                    align: 'right',
                    sortable: true,
                    value: 'so'
                },
                {
                    text: 'IP',
                    align: 'right',
                    sortable: true,
                    value: 'ip'
                }
            ]
        }
    },
    methods: {
        issueEdit(player_stats) {
            this.$router.push({name: 'admin_players_stats_edit', params: {id: player_stats.id}})
        },
        issueDelete(player_stats) {
            this.$store.dispatch('deletePlayerStats', {
                player_stats: player_stats
            })
        },
        getPlayerFullName(player_id) {
            return this.$store.getters.getPlayerFullNameById(player_id)
        },
        getTeamById(team_id) {
            return this.$store.getters.getTeamById(team_id)
        },
    },
    computed: {
        getDataSet() {
            if (this.hitting_pitching === 'hitting' && this.player_team === 'player') {
                if (this.season_playoffs === 'season') {
                    return this.$store.getters.getHittingPlayersSeasonStats
                }
                else if (this.season_playoffs === 'playoffs') {
                    return this.$store.getters.getHittingPlayersPlayoffStats
                }
            }
            else if (this.hitting_pitching === 'hitting' && this.player_team === 'team') {
                if (this.season_playoffs === 'season') {
                    return this.$store.getters.getHittingTeamsSeasonStats
                }
                else if (this.season_playoffs === 'playoffs') {
                    return this.$store.getters.getHittingTeamsPlayoffStats
                }
            }
            else if (this.hitting_pitching === 'pitching' && this.player_team === 'player') {
                if (this.season_playoffs === 'season') {
                    return this.$store.getters.getPitchingPlayersSeasonStats
                }
                else if (this.season_playoffs === 'playoffs') {
                    return this.$store.getters.getPitchingPlayersPlayoffStats
                }
            }
            else if (this.hitting_pitching === 'pitching' && this.player_team === 'team') {
                if (this.season_playoffs === 'season') {
                    return this.$store.getters.getPitchingTeamsSeasonStats
                }
                else if (this.season_playoffs === 'playoffs') {
                    return this.$store.getters.getPitchingTeamsPlayoffStats
                }
            }

            return null
        }
    },
    components: {
        TeamBadge
    }
}
</script>

<style scoped></style>
